(function () {
    'use strict';

    angular.module('pharmaPortalApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider
            .state('report', {
                parent : 'entity',
                url : '/report?page&sort&search',
                data : {
                    authorities : [ 'ROLE_USER' ],
                    pageTitle : 'pharmaPortalApp.report.home.title'
                },
                views : {
                    'content@' : {
                        templateUrl : 'app/entities/report/reports.html',
                        controller : 'ReportController',
                        controllerAs : 'vm'
                    }
                },
                params : {
                    page : {
                        value : '1',
                        squash : true
                    },
                    sort : {
                        value : 'id,asc',
                        squash : true
                    },
                    search : null
                },
                resolve : {
                    pagingParams : [ '$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page : PaginationUtil.parsePage($stateParams.page),
                            sort : $stateParams.sort,
                            predicate : PaginationUtil.parsePredicate($stateParams.sort),
                            ascending : PaginationUtil.parseAscending($stateParams.sort),
                            search : $stateParams.search
                        };
                    } ],
                    translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('report');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    } ]
                }
            })
            .state('report-detail', {
                parent : 'report',
                url : '/report/{id}',
                data : {
                    authorities : [ 'ROLE_USER' ],
                    pageTitle : 'pharmaPortalApp.report.detail.title'
                },
                views : {
                    'content@' : {
                        templateUrl : 'app/entities/report/report-detail.html',
                        controller : 'ReportDetailController',
                        controllerAs : 'vm'
                    }
                },
                resolve : {
                    translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('report');
                        return $translate.refresh();
                    } ],
                    entity : [ '$stateParams', 'Report', function($stateParams, Report) {
                        return Report.get({
                            id : $stateParams.id
                        }).$promise;
                    } ],
                    previousState : [ "$state", function($state) {
                        var currentStateData = {
                            name : $state.current.name || 'report',
                            params : $state.params,
                            url : $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    } ]
                }
            })
            .state('report-detail.edit', {
                parent : 'report-detail',
                url : '/detail/edit',
                data : {
                    authorities : [ 'ROLE_USER' ]
                },
                onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/report/report-dialog.html',
                        controller : 'ReportDialogController',
                        controllerAs : 'vm',
                        backdrop : 'static',
                        size : 'lg',
                        resolve : {
                            entity : [ 'Report', function(Report) {
                                return Report.get({
                                    id : $stateParams.id
                                }).$promise;
                            } ]
                        }
                    }).result.then(function() {
                        $state.go('^', {}, {
                            reload : true
                        });
                    }, function() {
                        $state.go('^');
                    });
                } ]
            })
            .state('report.new', {
                parent : 'report',
                url : '/new',
                data : {
                    authorities : [ 'ROLE_USER' ]
                },
                onEnter : ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/report/report-dialog.html',
                        controller : 'ReportDialogController',
                        controllerAs : 'vm',
                        backdrop : 'static',
                        size : 'lg',
                        resolve : {
                            entity : function() {
                                return {
                                    title : null,
                                    link : null,
                                    thumbnail : "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",
                                    thumbnailContentType : "image/png",
                                    reportGroup: null,
                                    id : null
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('report', null, {
                            reload : 'report'
                        });
                    }, function() {
                        $state.go('report');
                    });
                } ]
            })
            .state('report.edit', {
                parent : 'report',
                url : '/{id}/edit',
                data : {
                    authorities : [ 'ROLE_USER' ]
                },
                onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/report/report-dialog.html',
                        controller : 'ReportDialogController',
                        controllerAs : 'vm',
                        backdrop : 'static',
                        size : 'lg',
                        resolve : {
                            entity : [ 'Report', function(Report) {
                                return Report.get({
                                    id : $stateParams.id
                                }).$promise;
                            } ]
                        }
                    }).result.then(function() {
                        $state.go('report', null, {
                            reload : 'report'
                        });
                    }, function() {
                        $state.go('^');
                    });
                } ]
            })
            .state('report.delete', {
                parent : 'report',
                url : '/{id}/delete',
                data : {
                    authorities : [ 'ROLE_USER' ]
                },
                onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/report/report-delete-dialog.html',
                        controller : 'ReportDeleteController',
                        controllerAs : 'vm',
                        size : 'md',
                        resolve : {
                            entity : [ 'Report', function(Report) {
                                return Report.get({
                                    id : $stateParams.id
                                }).$promise;
                            } ]
                        }
                    }).result.then(function() {
                        $state.go('report', null, {
                            reload : 'report'
                        });
                    }, function() {
                        $state.go('^');
                    });
                } ]
            })
            .state('reportByReportGroup', {
                parent: 'report',
                url: '/{reportGroup}',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_INTRANET'],
                    pageTitle: 'pharmaPortalApp.reports.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/report/report-by-report-group.html',
                        controller: 'ReportByReportGroupController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('report');
                        return $translate.refresh();
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'report',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('reportByParent', {
                parent : 'report',
                url : '/{parent}',
                data : {
                    authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ],
                    pageTitle : 'pharmaPortalApp.reports.detail.title'
                },
                views : {
                    'content@' : {
                        templateUrl : 'app/entities/report/report-by-parent.html',
                        controller : 'ReportByParentController',
                        controllerAs : 'vm'
                    }
                },
                resolve : {
                    translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('report');
                        return $translate.refresh();
                    } ],
                    previousState : [ "$state", function($state) {
                        var currentStateData = {
                            name : $state.current.name || 'report',
                            params : $state.params,
                            url : $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    } ]
                }
            });
	}
})();
